module.exports = __webpack_public_path__ + "assets/img/thumb-LJ-Hooker-Spring-Campaign-Video.492b6fa9.jpg";